import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import { DocumentRequirement } from '../DocumentRequirement/DocumentRequirement';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const BusinessPlan = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title="Business plan"
      documentType="business plan"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <>
        <p>Include information on:</p>
        <ul>
          <li>The business being proposed</li>
          <li>Plans on generating revenue</li>
          <li>The size of investment needed</li>
          <li>How the funds will be used</li>
          <li>Details of the applicant's experience in the industry</li>
        </ul>
      </>
    </DocumentRequirement>
  );
};
